import React, { useState, useEffect } from "react"
import Api from "../../../../_helpers/Api"
import { trans } from "../../../../_providers/Translation"
import Skeleton from "react-loading-skeleton"

function PendingPartnerReservations() {
  const INITIAL_FILTERS = {
    partner_id: "",
    category_id: "",
  }

  const [data, setData] = useState({
    loading: true,
    partners: [],
    totalPending: 0,
    filtersContent: {
      categories: [],
      partners: [],
    },
  })
  const [filters, setFilters] = useState(INITIAL_FILTERS)

  useEffect(() => {
    loadData()
  }, [filters])

  const loadData = () => {
    setData((prev) => ({ ...prev, loading: true }))

    Api.get(
      `shared-reservations/statistics/pending-by-partner?partner_id=${filters.partner_id}&category_id=${filters.category_id}`,
    )
      .then((res) => {
        const payload = res.data?.data ?? res.data ?? {}
        setData({
          loading: false,
          partners: payload.by_partner || [],
          totalPending: payload.total_pending || 0,
          filtersContent: res.data?.filters,
        })
      })
      .catch((err) => {
        console.error("Error loading pending partner reservations:", err)
        setData({
          loading: false,
          partners: [],
        })
      })
  }

  const handleClearFilters = () => {
    setFilters(INITIAL_FILTERS)
  }

  function handleFilterChange(e) {
    const { name, value } = e.target

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <div className="pannel">
      <h3>
        {trans("headings.pendingReservationsFromPartners")} ({data.totalPending}
        )
      </h3>

      <div
        className="filter-standard"
        style={{
          width: "fit-content",
        }}
      >
        <div className="col">
          <select
            onChange={handleFilterChange}
            name="partner_id"
            style={{
              width: "fit-content",
            }}
            value={filters.partner_id}
          >
            <option value="">{trans("random.allTypes")}</option>
            <option value="online">{trans("tables.online")}</option>
            <option value="local">От системата</option>
          </select>
        </div>
        <div className="col">
          <select
            onChange={handleFilterChange}
            name="partner_id"
            style={{
              width: "fit-content",
            }}
            value={filters.partner_id}
          >
            <option value="">{trans("random.allPartners")}</option>
            {(data.filtersContent?.partners || []).map((partner) => (
              <option key={partner.id} value={partner.id}>
                {partner.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col">
          <select
            onChange={handleFilterChange}
            name="category_id"
            style={{
              width: "fit-content",
            }}
            value={filters.category_id}
          >
            <option value="">{trans("random.allCategories")}</option>
            {(data.filtersContent?.categories || []).map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        <div className="col">
          <button
            type="button"
            className="button-clear-filter"
            onClick={handleClearFilters}
          ></button>
        </div>
      </div>
      <hr />
      {data.loading ? (
        <Skeleton height={45} count={5} />
      ) : data.partners.length === 0 ? (
        <div
          className="alert warning"
          style={{
            width: "100%",
            marginBottom: "auto",
          }}
        >
          {trans("messages.noDataFound")}
        </div>
      ) : (
        <div className="ppr-chart">
          <div className="ppr-list-wrapper">
            {data.partners.map((p, idx) => {
              const maxCount = Math.max(
                ...data.partners.map((x) => Number(x.count)),
                1,
              )
              const i = Math.min(idx, 3)
              return (
                <div className="ppr-row" key={p.partner_name}>
                  <div className="ppr-row-head">
                    <span className="ppr-label">{p.partner_name}</span>
                    <span className="ppr-value">{p.count}</span>
                  </div>
                  <div className="ppr-bar-bg">
                    <div
                      className="ppr-bar"
                      style={{
                        backgroundColor: "#F9B578",
                        width: `${(Number(p.count) / maxCount) * 100}%`,
                      }}
                    />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default PendingPartnerReservations
